import React, { useEffect, useReducer } from "react";
import { Link, useLocation } from "react-router-dom";
import { BtnIcon } from "../Icons";
import { LOGGED_IN_USER_UPDATED } from "../../constants/sessionEvents";
import { STUDENT_NAV_TABS } from "../../constants/studentNavTabs";

const tabs = STUDENT_NAV_TABS;

const StudentHeaderSection = ({
  btnText = "Book a Free Demo",
  isBtnIcon = true,
  onClick,
}) => {
  const location = useLocation();
  const [, refresh] = useReducer((n) => n + 1, 0);

  useEffect(() => {
    const onStorage = () => refresh();
    window.addEventListener(LOGGED_IN_USER_UPDATED, onStorage);
    return () => window.removeEventListener(LOGGED_IN_USER_UPDATED, onStorage);
  }, []);

  const loggedInUser = JSON.parse(
    localStorage.getItem("loggedInUser") || "{}"
  );

  const hideActionButton =
    location.pathname === "/student" ||
    location.pathname === "/student/courses";

  return (
      <div className=" px-5 lg:px-12 2xl:pl-[73px] 2xl:pr-20 pt-10 lg:pt-14 2xl:pt-[70px]">
        <div className="flex items-center justify-between gap-6 flex-wrap">
          <div className="flex items-center gap-4 md:gap-6">
            <div className="h-20  md:h-28 w-20 md:w-28 overflow-hidden rounded-full ">
              <img
                src={
                  loggedInUser?.profilePicture ||
                  "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=200&q=80"
                }
                alt="Student profile"
                className="h-full w-full object-cover"
              />
            </div>

            <div>
              <h1 className="text-2xl text-[#1D2026] font-semibold leading-[-1%]">
                {loggedInUser?.firstName || "Student"} {loggedInUser?.lastName || ""}
              </h1>
              <p className="mt-1.5 text-base text-[#6E7485] ">
                {loggedInUser?.email || "student@email.com"}
              </p>
            </div>
          </div>

          {!hideActionButton && (
            <button
              type="button"
              onClick={onClick}
              className={`${isBtnIcon ? "inline-flex items-center gap-3" : ""} bg-[#FF6636] text-center mt-2  text-white text-base md:text-lg tracking-[-1%] leading-10 md:leading-[56px] px-5 md:px-8  md:min-w-56 font-semibold `}
            >
              {btnText}
              {isBtnIcon && <BtnIcon />}
            </button>
          )}
        </div>

        <div className="mt-12 md:mt-16 border-b border-t border-[#FF6636]">
          <nav className="grid grid-cols-6 gap-3  items-stretch  bg-white/0">
            {tabs.map((tab) => {
              const isActive = location.pathname === tab.path;

              return (
                <Link
                  key={tab.path}
                  to={tab.path}
                  className={` px-2  py-3 md:py-[19px] text-center text-sm md:text-base  font-semibold md:font-bold transition-colors ${
                    isActive
                      ? "bg-[#FF6636] text-white"
                      : "bg-white text-black hover:bg-white/90"
                  }`}
                >
                  {tab.label}
                </Link>
              );
            })}
          </nav>
        </div>
      </div>
  );
};

export default StudentHeaderSection;
